import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { AuthService } from "../../services";

export const SignOutPage = () => {
  useEffect(() => {
    AuthService.signOut();
  }, []);

  return <Redirect to="/auth/sign-in" />;
};
